import { decrypt } from "./crypto";

/**
 * ログイン中のユーザ情報を取得する
 * @returns ログイン中のユーザ情報
 */
export const getLoginUserInfo = () => {
  return decrypt(sessionStorage.userInfo);
}

const DEVELOPER_LIST = [
  "佐久間　大典",
  "栗原　幸夫",
  "栗崎　智裕",
  "HOANG　VAN　THANG",
];

export const checkIsDeveloper = () => {
  const userName = decrypt(sessionStorage.userInfo).userName;
  return DEVELOPER_LIST.includes(userName);
}